var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7749 6.88428C17.1149 6.94406 17.342 7.26811 17.2822 7.60807L15.6197 17.0633C15.6197 17.0633 15.6197 17.0633 15.6197 17.0633C15.4271 18.159 14.4753 18.9582 13.3627 18.9582H6.63728C5.52472 18.9582 4.5729 18.1591 4.38024 17.0633L2.71778 7.60807C2.658 7.2681 2.88514 6.94405 3.2251 6.88428C3.56507 6.82451 3.88912 7.05164 3.94889 7.39161L5.61136 16.8469C5.69893 17.3449 6.1316 17.7082 6.63728 17.7082H13.3627C13.8684 17.7082 14.3011 17.345 14.3886 16.8469L16.0511 7.3916C16.1109 7.05164 16.4349 6.8245 16.7749 6.88428Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85417 2.2915C8.27887 2.2915 7.8125 2.75787 7.8125 3.33317V4.37484H12.1875V3.33317C12.1875 2.75787 11.7211 2.2915 11.1458 2.2915H8.85417ZM6.5625 4.37484V3.33317C6.5625 2.06752 7.58851 1.0415 8.85417 1.0415H11.1458C12.4115 1.0415 13.4375 2.06752 13.4375 3.33317V4.37484H17.5C17.8452 4.37484 18.125 4.65466 18.125 4.99984C18.125 5.34502 17.8452 5.62484 17.5 5.62484H2.5C2.15482 5.62484 1.875 5.34502 1.875 4.99984C1.875 4.65466 2.15482 4.37484 2.5 4.37484H6.5625Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7e2e50d41a97d1d9adbe71b51dc49e54.svg";
export { ForwardRef as ReactComponent };